export const handleSetDrawType = (
  statefulDrawMapbox,
  mapType,
  startingCoords
) => {
  const drawType = mapType?.drawType;
  const modeOptions = startingCoords
    ? {
        from: {
          type: "Point",
          coordinates: startingCoords,
        },
      }
    : undefined;

  if (drawType === "area" || drawType === "lawn" || drawType === "mapbounds") {
    console.log("DRAWING POLYGON");
    statefulDrawMapbox?.changeMode("custom_draw_polygon", modeOptions);
  } else if (drawType === "bikeLane" || drawType === "path") {
    console.log("DRAWING LINE STRING");
    statefulDrawMapbox?.changeMode("custom_draw_line_string", modeOptions);
  } else if (drawType === "point") {
    console.log("DRAWING POINT");
    statefulDrawMapbox?.changeMode("custom_draw_point", modeOptions);
  } else {
    console.error("Unknown draw type:", drawType);
  }
};

export const handleTriggerDrawingFromLastVertex = (
  e,
  statefulDrawMapbox,
  featureId,
  setContinueFeat
) => {
  const feat = statefulDrawMapbox
    .getAll()
    .features?.find((feature) => feature.id === featureId);

  const featGeometry = feat?.geometry;

  const featCoords = featGeometry?.coordinates;

  console.log(featCoords, e?.featureTarget?.properties?.coord_path);
  if (
    featGeometry?.type !== "Polygon" &&
    featCoords &&
    featCoords.length - 1 === Number(e?.featureTarget?.properties?.coord_path)
    // ||  Number(e?.featureTarget?.properties?.coord_path) === 0

    //     ||
    // Number(e?.featureTarget?.properties?.coord_path) === 0
  ) {
    setContinueFeat(feat);

    // handleContinue(feat, featureId);
  } else {
    setContinueFeat(null);
  }
};

export const handleContinueDrawingFromLastVertex = (
  statefulDrawMapbox,
  startFeat
) => {
  const startFeature = {
    type: "FeatureCollection",
    features: [startFeat],
  };

  // Get the last point of the existing line segment
  const lastPoint =
    startFeature.features[0].geometry.coordinates[
      startFeature.features[0].geometry.coordinates.length - 1
    ];

  // Switch to custom_draw_line_string mode to continue drawing from the last point

  statefulDrawMapbox.add(startFeature);

  setTimeout(() => {
    statefulDrawMapbox.changeMode("custom_draw_line_string", {
      featureId: startFeature.features[0].id, // the ID of the existing line feature
      from: {
        type: "Point",
        coordinates: lastPoint
      }, // the last point of the existing line as a Point object
    });
  }, 100);
};

export const toggleTooltip = (
  e,
  tooltipRef,
  mapOffsetX,
  outerOffsetY,
  timeoutId
) => {
  const tooltip = tooltipRef.current;

  if (tooltip) {
    const offsetX = mapOffsetX + 10 || 10;
    const offsetY = outerOffsetY || 10;

    tooltip.style.transform = `translate(${e.point.x + offsetX}px, ${
      e.point.y + offsetY
    }px)`;
    tooltip.style.opacity = e.point.x ? 1 : 0;

    if (e.point.x) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        tooltip.style.opacity = 0;
      }, 2500);
    }
  }
};

export const undoCreateDrawing = (
  e,
  statefulDrawMapbox,
  featureId,
  mapType
) => {
  if (statefulDrawMapbox?.getMode() === "custom_draw_line_string") {
    const feat = statefulDrawMapbox
      .getAll()
      .features?.find((feature) => feature.id === featureId);
    const featCoords = feat?.geometry?.coordinates;

    if (
      featCoords &&
      featCoords.length - 2 === Number(e?.featureTarget?.properties?.coord_path)
    ) {
      if (mapType.drawType === "path" && featCoords.length <= 2) {
        return true;
      }

      // handleSaveAll(featureId);
    }
  }
};

/**
 * Safely executes a drawing operation on the map
 * @param map The map instance
 * @param operation A function that performs the drawing operation
 * @returns boolean indicating if the operation was successful
 */
export const safeDrawingOperation = (map: any, operation: (df: any) => void): boolean => {
  if (!map?.df) return false;
  try {
    operation(map.df);
    return true;
  } catch (error) {
    console.warn('Drawing operation failed:', error);
    return false;
  }
};
